import React from "react";
import { BsFacebook, BsLinkedin } from "react-icons/bs";
import { AiFillTwitterCircle } from "react-icons/ai";
import { RiInstagramFill } from "react-icons/ri";
import { FaPaypal } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import axiosInstance from "../../Axois/Axois";

const Footer = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [question, setQuestion] = useState("");

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone", phone);
    formData.append("email", email);
    formData.append("address", address);
    formData.append("question", question);
    try {
      const response = await axiosInstance.post("/contact", formData);

      console.log(response, "Contact12");
      if (response.data.status === true) {
        toast.success(response?.data?.message);
        setName("");
        setPhone("");
        setEmail("");
        setAddress("");
        setQuestion("");
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  return (
    <>
      {/* Newsletter sirf home page pe */}
  <div className="position-relative">
                {/* {location.pathname === "/" && (
        <div className="newsletter-section">
          <NewsLetter />
        </div>
      )} */}
      <div className="footerMaindiv12">
        <div className="container-fluid py-3 px-lg-5 px-md-4 footer12 footerMaindiv12 dark-border">
          <Toaster position="top-right" reverseOrder={false} />
          <div className="row mt-5 gy-4">
            {/* Share-Circle Description and Donate Link (Leftmost column in image) */}
            <div className="col-md-12 col-lg-4 col-12 order-lg-0 order-md-4 order-0">
              <div className="d-flex align-items-center mb-3">

                <div>
                  <Link to={"/"}>
                    <img src="../images/logo11.png" alt="Share Circle Logo" className="logo" />
                  </Link>
                </div>{/* Added heading for the logo section */}
              </div>
              <p>
                Share Circle is a Not-for-Profit Bitcoin-based lending platform, that seeks to deliver affordable lending solutions to entrepreneurs via the Bitcoin ecosystem. Run by Bitcoiners for Bitcoiners
              </p>

            </div>

            <div className="col-md-6 col-lg-2 col-12">
              <div className="my-3">
                <h3>EXPLORE</h3>
              <ul className="p-0 list-unstyled custom-list">
  <li><NavLink className="link-style2 disabled-link" to="#!">Success stories</NavLink></li>
  <li><NavLink className="link-style2 disabled-link" to="#!">Financial governance</NavLink></li>
  <li><NavLink className="link-style2 disabled-link" to="#!">Terms of use</NavLink></li>
  <li><NavLink className="link-style2 disabled-link" to="#!">Policies</NavLink></li>
  <li><NavLink className="link-style2 disabled-link" to="#!">Security & Trust</NavLink></li>
  <li><NavLink className="link-style2 disabled-link" to="#!">Bitcoin & Lightning Network</NavLink></li>
  <li><NavLink className="link-style2" to="#!">CSP Training & Support site</NavLink></li>
</ul>

              </div>
            </div>

            {/* Get To Know Us section (Third column from left) */}
            <div className="col-md-6 col-lg-2 col-12">
              <div className="my-3">
                <h3>GET TO KNOW US</h3>
                <ul className="p-0 list-unstyled custom-list">
                  <li>
                    <NavLink className="link-style2  " to={"#!"}>About us</NavLink>
                  </li>
                  <li>
                    <NavLink className="link-style2  " to={"#!"}>
                      How Share-Circle works
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="link-style2  " to={"#!"}>Why Share-Circle</NavLink>
                  </li>
                  <li>
                    <NavLink className="link-style2  disabled-link" to={"#!"}>
                      Our organizational profile
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="link-style2  disabled-link" to={"#!"}>Organisation board</NavLink>
                  </li>
                  <li>
                    <NavLink className="link-style2  disabled-link" to={"#!"}>Key partners</NavLink>
                  </li>
                  <li>
                    <NavLink className="link-style2  " to={"/Faq"}>
                      FAQs
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Us Form (Rightmost column) */}
            <div className="col-md-12 col-lg-4 col-12">
              <div className="my-3">
                <h3>Contact us</h3>
              </div>
              <div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <input
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                        type="text"
                        className="form-control mb-3"
                        style={{ padding: "10px", borderRadius: '40px' }}
                        placeholder="Enter your name"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <input
                        onChange={(e) => setPhone(e.target.value)}
                        value={phone}
                        type="text"
                        className="form-control mb-5"
                        style={{ padding: "10px", borderRadius: '40px' }}
                        placeholder="Enter your phone no."
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <input
                        onChange={(e) => setAddress(e.target.value)}
                        value={address}
                        type="text"
                        className="form-control mb-3"
                        style={{ padding: "10px", borderRadius: '40px' }}
                        placeholder="Enter your Addresss"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <input
                        onChange={(e) => setEmail(e.target.value)}
                        value={address}
                        type="text"
                        className="form-control mb-5"
                        style={{ padding: "10px", borderRadius: '40px' }}
                        placeholder="Enter your Email Address."
                      />
                    </div>
                  </div>
               
                  <div className="mb-3">
                    <textarea
                      onChange={(e) => setQuestion(e.target.value)}
                      value={question}
                      className="form-control mb-3"
                      rows="3"
                      style={{ padding: "10px", borderRadius: '40px' }}
                      id="message-text"
                      placeholder="Enter your question"
                    ></textarea>
                  </div>
                  <div className="text-center mb-3">
                    <button
                      type="submit"
                      className="btn btn-warning1 text-white"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Payment Methods and Copyright */}
          <div className="row my-3 bg-dark d-flex py-3 px-2 align-items-center round">
            <div className="col-12 d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">

              {/* FOLLOW US SECTION */}
              <div className="d-flex align-items-center gap-3 flex-wrap flex-column flex-sm-row text-center text-sm-start custom-follow-center">
                <h5 className="text-white mb-0 disabled-link">FOLLOW US</h5>
                <div className="d-flex align-items-center justify-content-center justify-content-sm-start gap-3 ">
                  <NavLink to={"#!"}><BsFacebook color="#999" size={30} /></NavLink>
                  <NavLink to={"#!"}><BsLinkedin color="#999" size={30} /></NavLink>
                  <NavLink to={"#!"}><AiFillTwitterCircle color="#999" size={35} /></NavLink>
                  <NavLink to={"#!"}><RiInstagramFill color="#999" size={35} /></NavLink>
                </div>
              </div>

              {/* PAYMENT ICONS SECTION */}
              <div className="d-flex align-items-center gap-3 flex-wrap justify-content-center custom-payment-grid">
                <img src="../images/bitcoin11.png" width="40" alt="bitcoin" />
                <img src="../images/visa-cart22.png" width="40" alt="visa" />
                <img src="../images/master-cart11.png" width="40" alt="master" />
                <img src="../images/lighting22.png" width="35" alt="lightning" />
                <img src="../images/tether.png" width="35" alt="Tether" />
                <FaPaypal style={{ fontSize: "35px", color: "#0079C1" }} />
              </div>

            </div>
          </div>



          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center gap-2 mt-3">
            <p className="fw-bold mb-0">
              Copyright @ 2025<span  style={{color:"#FFC107", fontSize:"16px"}}>Share-Circle</span> All Rights Reserved.
            </p>
            <div className="d-flex gap-3">
             <NavLink 
  to={"#!"} 
  className="link-style2 disabled-link" 
  style={{ color: "#999", pointerEvents: "none", cursor: "default" }}
>
  Privacy Policy
</NavLink>
              <NavLink to={"#!"} className="link-style2  disabled-link">Terms of Service</NavLink>
              <NavLink to={"#!"} className="link-style2  disabled-link ">Cookies Settings</NavLink>
            </div>
          </div>
        </div>
      </div>
  </div>
    </>
  );
};

export default Footer;
